module.exports = __webpack_public_path__ + "img/mis_ordenes.8283b407.jpg";